// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"7afd5846","425":"add08b35","510":"5ec337f5","532":"414d80e7","633":"53f7efa3","634":"26bc51ac","922":"1ff4ae62","937":"657fe4f9","972":"a04a9f48"}[chunkId] + ".chunk.js";
};